(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-mega"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initFooterAccordion() {
    var btns = document.querySelectorAll('.footer-mega__col-heading');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var isMobile = window.innerWidth <= 768;
        if (!isMobile) return;
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var targetId = this.getAttribute('aria-controls');
        var panel = document.getElementById(targetId);
        this.setAttribute('aria-expanded', !expanded);
        if (panel) panel.setAttribute('aria-hidden', expanded);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion);
  } else {
    initFooterAccordion();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
